import {all} from 'redux-saga/effects';
// import authSagas from './components/auth/Saga';

export default function* rootSaga(getState) {
  yield all([  
    //authSagas()   
  ]);
}
